import { render, staticRenderFns } from "./AssetClaimsTab.vue?vue&type=template&id=76fe14ae&scoped=true"
import script from "./AssetClaimsTab.vue?vue&type=script&lang=js"
export * from "./AssetClaimsTab.vue?vue&type=script&lang=js"
import style0 from "./AssetClaimsTab.vue?vue&type=style&index=0&id=76fe14ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fe14ae",
  null
  
)

export default component.exports